import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="#F5F6FA" />
    <rect x="15" y="19" width="10" height="2" rx="1" fill="#4F4E7B" />
  </svg>
);

const HyphenBlockIcon = (props) => <Icon component={svg} {...props} />;

export default HyphenBlockIcon;
